<template>
  <div class="app-card">
    <n-flex class="app-head-flex" justify="space-between" align="center">
      <n-flex align="center" :size="24">
        <n-image class="app-icon" width="100" height="100" :src="icon" preview-disabled/>
        <n-flex vertical justify="center">
          <div class="app-title">{{ name }}</div>
          <div class="app-desc">{{ text }}</div>
        </n-flex>
      </n-flex>
      <n-button class="download-btn" type="primary" size="large" round @click="toDownload">
        点击下载
      </n-button>
    </n-flex>
    
    <div class="screenshot-scroll">
      <div class="screenshot-wrapper" v-for="image in storeImages" :key="image">
        <img 
          class="screenshot" 
          :src="image" 
          loading="lazy"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {NButton, NFlex, NImage} from "naive-ui";

export default {
  name: 'AppShowItem',
  components: {NButton, NImage, NFlex},
  props: ['icon', 'name', 'text', 'downloadUrl', 'storeImages'],
  methods: {
    toDownload() {
      window.open(this.downloadUrl, '_blank')
    }
  }
}
</script>

<style scoped>
.app-card {
  background: var(--glass-bg);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--glass-border);
  border-radius: 24px;
  padding: 32px;
  margin-bottom: 40px;
  transition: all 0.3s ease;
}

.app-card:hover {
  border-color: rgba(99, 226, 183, 0.3);
  box-shadow: var(--glass-shadow);
}

.app-head-flex {
  margin-bottom: 32px;
}

.app-icon {
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.app-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-color);
  margin-bottom: 8px;
}

.app-desc {
  font-size: 15px;
  color: var(--text-secondary);
  max-width: 600px;
  line-height: 1.6;
}

.download-btn {
  background: linear-gradient(135deg, #63e2b7 0%, #42c59a 100%);
  border: none;
  font-weight: 600;
  padding: 0 32px;
  height: 44px;
  color: #101014;
  transition: transform 0.2s;
}

.download-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 0 20px rgba(99, 226, 183, 0.4);
}

.screenshot-scroll {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 16px;
  /* Hide scrollbar for cleaner look but keep functionality */
  scrollbar-width: thin;
  scrollbar-color: var(--glass-border) transparent;
}

.screenshot-wrapper {
  flex: 0 0 220px; /* Fixed width for screenshots */
  height: 400px;   /* Fixed height to ensure full display */
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
  background: rgba(0,0,0,0.2);
}

.screenshot-wrapper:hover {
  transform: translateY(-5px);
}

.screenshot {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
</style>